<template>
    <div id="app" class='page-wrapper'>

        <Header />
        <Banner :class='hasBanner ? "show-banner" : "hide-banner"' class='banner' :name='name' />
        <transition name='fade'>
            <router-view />
        </transition>
        <Footer />
        
    </div>
</template>

<style lang="scss">

</style>

<script>
// import components
import Header from '@/components/global/Header.vue';
import Footer from '@/components/global/Footer.vue';
import Banner from '@/components/Banner.vue';

export default {
    computed: {
        name() {
            return this.$route.name;
        },
        hasBanner() {
            if (this.name.toLowerCase().includes('home')) {
                return false;
            } else {
                return true;
            }
        }
    },
    components: {
        Header, Footer, Banner
    },
}
</script>